import React, { useCallback, useState } from 'react';
import { useQuery } from '@apollo/client';
import {
  CommerceAddress,
  FetchShipToInPpcQuery,
  FetchShipToInPpcQueryVariables,
} from '@css-xp/graphtypes/src/generated-types-new';
import { fetchShipToInPPC } from './queries/fetch-ship-to';
import { DEFAULT_PAGE, DEFAULT_ROWS_PER_PAGE } from '@atlassian/cssxp-utils-entitlement';
import { SoldToAddressTable } from './sold-to-address-table';

interface Props {
  txaId: string;
  billToAddress?: CommerceAddress | null;
  availablePaymentMethods?: any;
  hidePricingEligibility?: boolean;
  showAddAddress?: boolean;
  hideActions?: boolean;
  showSearchBox?: boolean;
  searchTerm?: string;
  hideEdit?: boolean;
  hideAddFromBillToAddress?: boolean;
}

export const SoldToAddressForTxa = ({
  txaId,
  billToAddress,
  availablePaymentMethods,
  hidePricingEligibility,
  showAddAddress,
  hideActions,
  showSearchBox,
  searchTerm = '',
  hideEdit,
  hideAddFromBillToAddress,
}: Props) => {
  const [rowsPerPage, setRowsPerPage] = useState(DEFAULT_ROWS_PER_PAGE);
  const [currentPage, setCurrentPage] = useState(DEFAULT_PAGE);

  const { data, loading, refetch } = useQuery<FetchShipToInPpcQuery, FetchShipToInPpcQueryVariables>(fetchShipToInPPC, {
    variables: {
      searchParams: {
        query: searchTerm,
        transactionAccountId: txaId,
      },
      pageParams: {
        size: rowsPerPage,
        cursor: null,
      },
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-and-network',
    skip: !txaId,
  });

  const onPageChange = useCallback(
    (newPage: number) => {
      setCurrentPage(newPage);
      refetch({
        pageParams: {
          size: rowsPerPage,
          cursor: data?.shipToParty?.pageInfo?.endCursor,
        },
      });
    },
    [rowsPerPage, currentPage, data]
  );

  const handleRowChange = useCallback(
    (newRowPerPage: number) => {
      if (newRowPerPage === rowsPerPage) {
        return;
      }
      setRowsPerPage(newRowPerPage);
      setCurrentPage(1);
      refetch({
        pageParams: {
          size: newRowPerPage,
          cursor: null,
        },
      });
    },
    [rowsPerPage]
  );

  const onSearch = useCallback((searchTerm: string) => {
    refetch({
      searchParams: {
        query: searchTerm,
        transactionAccountId: txaId,
      },
      pageParams: {
        size: rowsPerPage,
        cursor: null,
      },
    });
  }, []);
  const response = data?.shipToParty;
  return (
    <div data-testid="transaction-account-ship-to-address">
      <SoldToAddressTable
        // @ts-ignore
        addressResponse={response}
        loading={loading}
        transactionAccountId={txaId}
        billToAddress={billToAddress}
        onSearch={onSearch}
        availablePaymentMethods={availablePaymentMethods}
        hidePricingEligibility={hidePricingEligibility}
        showAddAddress={showAddAddress}
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        onRowChange={handleRowChange}
        onPageChange={onPageChange}
        hideActions={hideActions}
        showSearchBox={showSearchBox}
        refetch={refetch}
        hideEdit={hideEdit}
        hideAddFromBillToAddress={hideAddFromBillToAddress}
      />
    </div>
  );
};
